import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getStrategicAxes() {
      return getState().strategicAxes;
    },
    isRetrieveStrategicAxesRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveStrategicAxesRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveStrategicAxesRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
